import {createRouter, createWebHistory} from 'vue-router'
//users
import Login from '@/views/user/Login.vue'
import Forgot from '@/views/user/Forgot.vue'
import SetPassword from '@/views/user/SetPassword.vue'
import Settings from '@/views/user/Settings.vue'
import Tariff from '@/views/user/Tariff.vue'
import Project from '@/views/project/Project.vue'
import ProjectChange from '@/views/project/ProjectChange.vue'

//dictionary

import ProjectSettings from '@/views/project/ProjectSettings.vue'
import ReviewReports from '@/views/dictionary/review/ReviewReports.vue'
import HistoryChange from '@/views/user/HistoryChange.vue'
import ParserProcess from '@/views/dictionary/review/ParserProcess.vue'
import ProjectStat from '@/views/dictionary/review/ProjectStat.vue'
import ProjectReviews from '@/views/dictionary/review/ProjectReviews.vue'
import ProjectAlerts from '@/views/dictionary/review/ProjectAlerts.vue'
import ProjectAnalytic from '@/views/dictionary/review/ProjectAnalytic.vue'
import ProjectBusiness from '@/views/business/ProjectBusiness.vue'

import UserAgreement from '@/views/UserAgreement'
import Front from '@/views/Front.vue'
import PageNotFound from '@/views/PageNotFound.vue'
import store from '@/store/index'
import ProjectPermActivate from "@/views/project/ProjectPermActivate.vue";
import AdminDashboard from "@/views/service_status/AdminDashboard.vue";
import ReportDownload from "@/views/user/ReportDownload.vue";
// import ProjectCompanyType from "@/views/ct/ProjectCompanyType.vue";


const router = new createRouter({
    history: createWebHistory("/"),
    routes: [
        // {
        //     path: '/company_type',
        //     name: 'company_type',
        //     component: ProjectCompanyType,
        //     meta: {
        //         requiresAuth: true
        //     }
        // },
        {
            path: '/user-agreement',
            name: 'user_agreement',
            component: UserAgreement,
            meta: {
                notAuth: true,
                title: "Соглашение об обработке персональных данных"
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                notAuth: true,
            }
        },
        {
            path: '/tariff',
            name: 'tariff',
            component: Tariff,
            meta: {
                notAuth: false
            }
        },
        {
            path: '/project',
            name: 'project',
            component: Project,
            meta: {
                notAuth: false,
                requiresAuth: true,
                notCheckProject: true,
                onTop: true
            }
        },
        {
            path: '/project/:id',
            name: 'project_change',
            component: ProjectChange,
            meta: {
                notAuth: false,
                requiresAuth: true,
                notCheckProject: true,
                onTop: true
            }
        },
        {
            path: '/protected_report_download/:id/:report_type',
            name: 'protected_report_download',
            component: ReportDownload,
            meta: {
                notAuth: false,
                requiresAuth: true,
                notCheckProject: true,
                // onTop: true
            }
        },
        // {
        //     path: '/registration',
        //     name: 'registration',
        //     component: Registration,
        //
        //     meta: {
        //         notAuth: true
        //     }
        // },
        // {
        //     path: '/registration/:activate_code',
        //     name: 'registration_activate',
        //     component: RegistrationActivate,
        //     meta: {
        //         notAuth: true
        //     }
        // },
        {
            path: '/forgot_password',
            name: 'forgot',
            component: Forgot,
            meta: {
                notAuth: true
            }
        },
        {
            path: '/set_password/:uid/:token',
            name: 'set_password',
            component: SetPassword,
            meta: {
                notAuth: true
            }
        },


        {
            path: '/dashboard',
            name: 'base',
            component: Front,
            meta: {
                requiresAuth: true
            }
        },

        {
            path: '/',
            name: 'project_business',
            component: ProjectBusiness,
            meta: {
                requiresAuth: true,
                // requiresRule: true
            }
        },


        {
            path: '/status_page',
            name: 'admin_dashboard',
            component: AdminDashboard,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/profile_settings',
            name: 'profile_settings',
            component: Settings,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/settings',
            name: 'project_settings',
            component: ProjectSettings,
            meta: {
                requiresAuth: true,
                // requiresRule: true
            }
        },
        {
            path: '/parser',
            name: 'parser_process',
            component: ParserProcess,
            meta: {
                requiresAuth: true,
                // requiresRule: true
            }
        },
        {
            path: '/statistics',
            name: 'project_stat',
            component: ProjectStat,
            meta: {
                requiresAuth: true,
                // requiresRule: true
            }
        },
        {
            path: '/analytics',
            name: 'project_analytics',
            component: ProjectAnalytic,
            meta: {
                requiresAuth: true,
                // requiresRule: true
            }
        },
        {
            path: '/reviews',
            name: 'project_reviews',
            component: ProjectReviews,
            meta: {
                requiresAuth: true,
                // requiresRule: true
            }
        },
        {
            path: '/alerts',
            name: 'project_alerts',
            component: ProjectAlerts,
            meta: {
                requiresAuth: true,
                // requiresRule: true
            }
        },
        {
            path: '/reports',
            name: 'reports',
            component: ReviewReports,
            meta: {
                requiresAuth: true,
                // requiresRule: true
            }
        },
        {
            path: '/history',
            name: 'history',
            component: HistoryChange,
            meta: {
                requiresAuth: true,
                // requiresRule: true
            }
        },
        {
            path: '/activate/:code/:uuid/:token',
            name: 'project_perm_activate',
            component: ProjectPermActivate,
            meta: {
                onTop: true,
                notAuth: true
            }
        },

        {
            path: "/404", name: '404',
            component: PageNotFound,
            meta: {
                title: 'Страница не найдена',
                notAuth: true
            }
        },
        {
            path: "/:pathMatch(.*)",
            name: 'PageNotFound',
            component: PageNotFound,
            notAuth: true
        }
    ],
    linkActiveClass: "active",
    linkExactActiveClass: "exact-active",
});

export default router

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || store.getters.company.name;
    next();
});
router.beforeEach((to, from, next) => {
    store.commit('set_route', to);
    store.dispatch('init', (!to.meta.notAuth)).then(() => {

        if (to.matched.some(record => record.meta.requiresAuth)) {
            if (store.getters.isLoggedIn) {
                if (to.matched.some(record => !record.meta.notCheckProject)) {
                    if (store.getters.currentProjectId) {
                        next();
                        return
                    }
                    router.push({path: '/project'})
                    return;
                } else {
                    next();
                    return
                }
            }
            router.push({path: '/login', query: {next: to.fullPath}})
        } else if (to.matched.some(record => record.meta.notAuth)) {
            if (store.getters.isLoggedIn) {
                router.push({path: '/'})
            } else {
                next();
                return
            }

        } else {
            next()
        }
    }, error => {
        console.log(error)
    }).catch((e) => console.error(e))

});
